import { getUrl } from '../config';
import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import styled from "@emotion/styled";

import { CssBaseline } from "@mui/material";

import GlobalStyle from "../components/GlobalStyle";

const Root = styled.div`
  max-width: ${(props) => (props.$fullWidth ? "none" : "520px")};
  width: ${(props) => (props.$fullWidth ? "100%" : "auto")};
  min-height: ${(props) => (props.$fullWidth ? "100vh" : "100%")};
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const Auth = ({ children }) => {
  const location = useLocation();
  const isSignIn = location.pathname?.includes("sign-in");

  return (
    <Root $fullWidth={isSignIn}>
      <CssBaseline />
      <GlobalStyle />
      {children}
      <Outlet />
    </Root>
  );
};

export default Auth;
